/* SELVÉ V2 — animations et comportements (refonte 2026) */
(function(){
  var d=document, root=d.documentElement;
  root.classList.add('sv-js');
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Apparitions au défilement */
  function reveal(){
    var els=d.querySelectorAll('[data-sv-reveal]:not(.is-in),[data-sv-mask]:not(.is-in),.sv-count:not(.is-in)');
    if(!('IntersectionObserver' in window)||reduce){ els.forEach(function(e){e.classList.add('is-in')}); counters(); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); if(en.target.classList.contains('sv-count')) count(en.target); io.unobserve(en.target);} });
    },{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(e){ io.observe(e); });
  }
  /* 2. Compteur (liste d'attente) */
  function count(el){
    var n=el.querySelector('.sv-count__num'); if(!n) return;
    var to=parseInt(n.getAttribute('data-to'),10)||0, t0=null, dur=1600;
    function step(ts){ if(!t0) t0=ts; var p=Math.min(1,(ts-t0)/dur); var e=1-Math.pow(1-p,4); n.textContent=Math.round(to*e); if(p<1) requestAnimationFrame(step); }
    if(reduce){ n.textContent=to; return; } requestAnimationFrame(step);
  }
  function counters(){ d.querySelectorAll('.sv-count').forEach(count); }

  /* 3. Parallaxe douce des grandes images */
  var par=[].slice.call(d.querySelectorAll('.sv-banner__media img'));
  var prog=null;
  var ticking=false;
  function onScroll(){
    if(ticking) return; ticking=true;
    requestAnimationFrame(function(){
      var vh=window.innerHeight;
      if(!reduce) par.forEach(function(img){ var r=img.parentNode.getBoundingClientRect(); if(r.bottom<0||r.top>vh) return; var c=(r.top+r.height/2-vh/2)/vh; img.style.setProperty('--sv-par',(c*-40).toFixed(1)+'px'); });
      if(prog){ var h=d.documentElement.scrollHeight-vh; prog.style.transform='scaleX('+(h>0?Math.min(1,window.scrollY/h):0)+')'; }
      if(hasBars) waLift();
      ticking=false;
    });
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});

  /* 4. Hauteur de l'en-tête (barre filtre collante) */
  function headerH(){ var h=d.querySelector('header.page-header, .page-header'); if(h) root.style.setProperty('--sv-header-h',(h.classList.contains('sticky-show')?h.offsetHeight:0)+'px'); }
  window.addEventListener('scroll',function(){ if(!hdrT){ hdrT=setTimeout(function(){ hdrT=null; headerH(); },250); } },{passive:true});
  var hdrT=null;

  /* 5. WhatsApp : remonte au-dessus des barres d'achat fixes, s'ouvre brièvement */
  var wa=d.querySelector('.sv-wa');
  var hasBars=!!d.querySelector('[data-sv-sticky-bar], .sp-sticky');
  function waLift(){
    if(!wa) return;
    var lift=0;
    d.querySelectorAll('[data-sv-sticky-bar], .sp-sticky, .product-sticky, .sticky-atc, .wt-product__sticky').forEach(function(b){ var r=b.getBoundingClientRect(); var st=getComputedStyle(b); if(st.display!=='none'&&st.visibility!=='hidden'&&r.height>0&&r.top<window.innerHeight&&r.bottom>=window.innerHeight-2) lift=Math.max(lift,r.height+8); });
    wa.style.setProperty('--sv-wa-lift',lift+'px');
  }

  /* 6. Formulaire liste d'attente : message sans rechargement visuel */
  d.querySelectorAll('[data-sv-wait-form]').forEach(function(f){
    f.addEventListener('submit',function(){ try{ sessionStorage.setItem('sv-wait','1'); }catch(e){} });
  });

  /* 7. Carrousels produits : barre de progression + flèches */
  function rails(){
    d.querySelectorAll('[data-sv-rail]:not(.is-rail)').forEach(function(r){
      r.classList.add('is-rail');
      var t=r.querySelector('.sv-rail__track'), f=r.querySelector('.sv-rail__fill'), prev=r.querySelector('[data-dir="-1"]'), next=r.querySelector('[data-dir="1"]');
      if(!t) return;
      var sw=0, cw=0, max=0, ratio=1, ticking=false;
      function measure(){ sw=t.scrollWidth; cw=t.clientWidth; max=Math.max(0,sw-cw); ratio=sw?Math.min(1,cw/sw):1; }
      function upd(){
        ticking=false;
        var x=t.scrollLeft, pos=max>0?Math.min(1,Math.max(0,x/max)):0;
        if(f) f.style.transform='translate3d('+(pos*(1-ratio)*100)+'%,0,0) scaleX('+ratio+')';
        if(prev){ var a=x<=2; if(prev.disabled!==a) prev.disabled=a; }
        if(next){ var b=x>=max-2; if(next.disabled!==b) next.disabled=b; }
      }
      function req(){ if(!ticking){ ticking=true; requestAnimationFrame(upd); } }
      t.addEventListener('scroll',req,{passive:true});
      window.addEventListener('resize',function(){ measure(); req(); },{passive:true});
      window.addEventListener('load',function(){ measure(); req(); });
      measure(); upd();
      [prev,next].forEach(function(b){ if(!b) return; b.addEventListener('click',function(){ var c=t.querySelector('.sv-card'); var w=c?c.getBoundingClientRect().width+1:cw/2; t.scrollBy({left:w*2*parseInt(b.getAttribute('data-dir'),10),behavior:reduce?'auto':'smooth'}); }); });
    });
  }

  /* 8. Passer à la caisse : départ immédiat vers le paiement (sans repasser par le formulaire du panier) */
  d.addEventListener('click',function(e){
    var b=e.target.closest('#CartDrawer-Checkout, button[name="checkout"], input[name="checkout"]');
    if(!b||b.disabled) return;
    e.preventDefault(); e.stopPropagation();
    b.classList.add('sv-going');
    window.location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'checkout';
  },true);

  /* 9. Suggestions du panier : un clic sur une taille = ajout direct */
  d.addEventListener('click',function(e){
    var b=e.target.closest('[data-sv-quick-add]');
    if(!b||b.classList.contains('is-busy')) return;
    e.preventDefault();
    b.classList.add('is-busy');
    fetch((window.routes&&window.routes.cart_add_url)||'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:parseInt(b.getAttribute('data-sv-quick-add'),10),quantity:1})})
      .then(function(r){return r.json()})
      .then(function(res){
        b.classList.remove('is-busy');
        if(res&&res.status){ return; }
        b.classList.add('is-done');
        var cd=d.querySelector('cart-drawer');
        setTimeout(function(){
          if(cd&&typeof cd.refreshCartDrawer==='function'){ cd.refreshCartDrawer(); }
          else { d.dispatchEvent(new CustomEvent('cart-drawer:refresh',{bubbles:true})); }
          if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){ publish(PUB_SUB_EVENTS.cartUpdate,{source:'sv-quick-add'}); }
        },350);
      }).catch(function(){ b.classList.remove('is-busy'); });
  });

  /* 10. Pages collection : les articles suivants se chargent tout seuls en descendant */
  function infinite(){
    d.querySelectorAll('.sv-more[data-sv-next]:not(.is-inf)').forEach(function(m){
      var grid=m.parentNode&&m.parentNode.querySelector('.sv-grid');
      if(!grid||!('IntersectionObserver' in window)) return;
      m.classList.add('is-inf');
      var busy=false;
      var io=new IntersectionObserver(function(en){
        if(!en[0].isIntersecting||busy) return;
        var url=m.getAttribute('data-sv-next');
        if(!url){ io.disconnect(); m.remove(); return; }
        busy=true; m.classList.add('is-loading');
        fetch(url,{credentials:'same-origin'}).then(function(r){return r.text()}).then(function(html){
          var doc=new DOMParser().parseFromString(html,'text/html');
          var g=doc.querySelector('.sv-coll .sv-grid');
          if(g){ [].slice.call(g.children).forEach(function(c){ if(!c.classList.contains('sv-wide')) grid.appendChild(c); }); }
          var nm=doc.querySelector('.sv-more[data-sv-next]');
          busy=false; m.classList.remove('is-loading');
          if(nm){ m.setAttribute('data-sv-next',nm.getAttribute('data-sv-next')); io.unobserve(m); io.observe(m); }
          else { io.disconnect(); m.remove(); }
        }).catch(function(){ busy=false; m.classList.remove('is-loading'); });
      },{rootMargin:'0px 0px 1200px 0px'});
      io.observe(m);
    });
  }

  /* 11. Défilement continu (accueil) : avance tout seul ; au doigt on peut aller et revenir ; reprend après 1,5 s */
  function marquees(){
    d.querySelectorAll('.sv-mq:not(.is-mq)').forEach(function(box){
      box.classList.add('is-mq');
      var tr=box.querySelector('.sv-mq__track'), set=box.querySelector('.sv-mq__set');
      if(!tr||!set||reduce) return;
      var dur=parseFloat(getComputedStyle(box).getPropertyValue('--sv-mq-dur'))||60;
      var sx=0, sy=0, bx=0, down=false, moved=false, pid=null, t=null;
      function cur(){ var m=getComputedStyle(tr).transform; if(!m||m==='none') return 0; return new DOMMatrix(m).m41; }
      function wrap(x){ var w=set.getBoundingClientRect().width; if(!w) return x; while(x>0) x-=w; while(x<=-w) x+=w; return x; }
      function go(x){ var w=set.getBoundingClientRect().width||1; tr.style.transform=''; tr.style.animation=''; tr.style.animationDelay=(-(-x/w)*dur)+'s'; }
      box.addEventListener('pointerdown',function(e){
        if(e.pointerType==='mouse'&&e.button!==0) return;
        sx=e.clientX; sy=e.clientY; bx=cur(); down=true; moved=false; pid=e.pointerId; clearTimeout(t);
      },{passive:true});
      box.addEventListener('pointermove',function(e){
        if(!down||e.pointerId!==pid) return;
        var dx=e.clientX-sx, dy=e.clientY-sy;
        if(!moved){
          if(Math.abs(dx)<8&&Math.abs(dy)<8) return;
          if(Math.abs(dy)>Math.abs(dx)){ down=false; return; }
          moved=true; tr.style.animation='none';
          try{ box.setPointerCapture(pid); }catch(_){}
        }
        tr.style.transform='translate3d('+wrap(bx+dx)+'px,0,0)';
      },{passive:true});
      function end(){
        if(!down) return; down=false;
        if(!moved) return;
        var x=wrap(cur()); tr.style.transform='translate3d('+x+'px,0,0)';
        t=setTimeout(function(){ go(x); },1500);
      }
      box.addEventListener('pointerup',end); box.addEventListener('pointercancel',end);
      box.addEventListener('click',function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); moved=false; } },true);
      box.addEventListener('dragstart',function(e){ e.preventDefault(); });
    });
  }

  /* 12. Ajout rapide : le « + » d'une carte ouvre le choix de taille, puis ajoute au panier */
  var L=(root.lang||'fr').slice(0,2);
  var TX={fr:['Choisissez votre taille','Voir le produit','Ajouté'],en:['Choose your size','View product','Added'],de:['Größe wählen','Produkt ansehen','Hinzugefügt'],it:['Scegli la taglia','Vedi il prodotto','Aggiunto'],es:['Elige tu talla','Ver el producto','Añadido'],nl:['Kies je maat','Bekijk product','Toegevoegd'],da:['Vælg størrelse','Se produkt','Tilføjet'],sv:['Välj storlek','Se produkt','Tillagd'],nb:['Velg størrelse','Se produkt','Lagt til'],uk:['Оберіть розмір','Переглянути','Додано']}[L]||['Choisissez votre taille','Voir le produit','Ajouté'];
  var sheet=null;
  function money(c){ try{ return new Intl.NumberFormat(root.lang||'fr-FR',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'}).format(c/100); }catch(e){ return (c/100).toFixed(2)+' €'; } }
  function closeSheet(){ if(sheet){ sheet.classList.remove('is-on'); } }
  function openCart(){
    var cd=d.querySelector('cart-drawer');
    if(!cd){ location.href=(window.routes&&window.routes.cart_url)||'/cart'; return; }
    var p=null; try{ if(typeof cd.refreshCartDrawer==='function') p=cd.refreshCartDrawer(); }catch(e){}
    Promise.resolve(p).then(function(){ setTimeout(function(){ cd.classList.remove('is-empty','wt-cart--empty'); if(!cd.isOpen&&typeof cd.toggleDrawerClasses==='function') cd.toggleDrawerClasses(); },200); });
    if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){ publish(PUB_SUB_EVENTS.cartUpdate,{source:'sv-qa'}); }
  }
  function showSheet(p){
    if(!sheet){
      sheet=d.createElement('div'); sheet.className='sv-qs';
      sheet.innerHTML='<div class="sv-qs__bg" data-close></div><div class="sv-qs__panel" role="dialog" aria-modal="true"><button type="button" class="sv-qs__x" data-close aria-label="×">×</button><div class="sv-qs__head"><img alt=""><div><p class="sv-qs__name"></p><p class="sv-qs__price"></p></div></div><p class="sv-qs__label"></p><div class="sv-qs__sizes"></div><a class="sv-qs__more"></a></div>';
      d.body.appendChild(sheet);
      sheet.addEventListener('click',function(e){ if(e.target.closest('[data-close]')) closeSheet(); });
      d.addEventListener('keydown',function(e){ if(e.key==='Escape') closeSheet(); });
    }
    var img=sheet.querySelector('.sv-qs__head img'); img.src=p.featured_image?(p.featured_image+(p.featured_image.indexOf('?')>-1?'&':'?')+'width=200'):'';
    sheet.querySelector('.sv-qs__name').textContent=p.title;
    sheet.querySelector('.sv-qs__price').textContent=money(p.price);
    sheet.querySelector('.sv-qs__label').textContent=TX[0];
    var more=sheet.querySelector('.sv-qs__more'); more.textContent=TX[1]; more.href='/products/'+p.handle;
    var box=sheet.querySelector('.sv-qs__sizes'); box.innerHTML='';
    p.variants.forEach(function(v){
      if(!v.available) return;
      var b=d.createElement('button'); b.type='button'; b.className='sv-qs__size'; b.textContent=v.option1||v.title;
      b.addEventListener('click',function(){
        if(b.classList.contains('is-busy')) return; b.classList.add('is-busy');
        fetch((window.routes&&window.routes.cart_add_url)||'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:v.id,quantity:1})})
          .then(function(r){return r.json()}).then(function(res){
            b.classList.remove('is-busy'); if(res&&res.status) return;
            b.classList.add('is-done'); b.textContent=TX[2];
            setTimeout(function(){ closeSheet(); openCart(); },350);
          }).catch(function(){ b.classList.remove('is-busy'); });
      });
      box.appendChild(b);
    });
    requestAnimationFrame(function(){ sheet.classList.add('is-on'); });
  }
  d.addEventListener('click',function(e){
    var b=e.target.closest('[data-sv-qa]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var h=b.getAttribute('data-sv-qa');
    fetch('/products/'+h+'.js').then(function(r){return r.json()}).then(showSheet).catch(function(){ location.href='/products/'+h; });
  },true);

  function init(){ reveal(); onScroll(); headerH(); rails(); infinite(); marquees(); }
  if(d.readyState!=='loading') init(); else d.addEventListener('DOMContentLoaded',init);
  d.addEventListener('shopify:section:load',init);
})();
